const terminalWindow = document.getElementById('terminal-window');
const terminalBody = document.getElementById('terminal-body');
const terminalLines = document.getElementById('terminal-lines');
const terminalInput = document.getElementById('terminal-input');
const terminalOverlay = document.getElementById('terminal-overlay');

let isActive = false;
let history = [];
let historyIndex = -1;

const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

const addLine = (text, cls = "") => {
    const div = document.createElement('div');
    if (cls) div.className = cls;
    div.textContent = text;
    terminalLines.appendChild(div);
    scrollToBottom();
};

const addBlock = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    terminalLines.appendChild(div);
    scrollToBottom();
};

const clearTerminal = () => {
    terminalLines.innerHTML = '';
};

const scrollToBottom = () => {
    terminalBody.scrollTop = terminalBody.scrollHeight;
};

const showBanner = () => {
    addBlock(`
<pre class="text-green-400">
██████╗ ██████╗  █████╗ ██╗  ██╗ █████╗ ███████╗██╗  ██╗
██╔══██╗██╔══██╗██╔══██╗██║ ██╔╝██╔══██╗██╔════╝██║  ██║
██████╔╝██████╔╝███████║█████╔╝ ███████║███████╗███████║
██╔═══╝ ██╔══██╗██╔══██║██╔═██╗ ██╔══██║╚════██║██╔══██║
██║     ██║  ██║██║  ██║██║  ██╗██║  ██║███████║██║  ██║
╚═╝     ╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝
</pre>

<div class="text-yellow-400 font-bold mt-2">👨‍💻 PRAKASH RAJ TERMINAL PORTFOLIO</div>
<div class="text-gray-400 mt-2">Type 'help' to see available commands.</div>
    `);
};

const boot = async () => {
    addLine("Booting Prakash Raj Developer Terminal...", "text-cyan-400");
    await sleep(1000);
    addLine("Loading modules...");
    await sleep(1000);
    addLine("Initializing portfolio...");
    await sleep(1000);

    clearTerminal();
    showBanner();
};

const handleCommand = (cmd) => {
    switch (cmd.toLowerCase().trim()) {
      case "help":
        addBlock(`
<br>Available Commands:<br><br>
about - About me<br>
skills - My skills<br>
projects - My projects<br>
contact - Contact details<br>
github - My GitHub profile<br>
photo - My image<br>
clear - Clear terminal<br>
exit - Exit portfolio<br>
        `);
        break;

      case "about":
        addBlock(`
<br>Name : <b class="text-yellow-400">PRAKASH RAJ</b><br>
Role : Computer Science Engineering Student<br>
Goal : Full Stack Developer<br><br>
Currently learning:<br>
- React.js<br>
- Java<br>
- Three.js Development<br>
        `);
        break;

      case "skills":
        addBlock(`
<br>Technical Skills:<br><br>
• React.js<br>
• Tailwind<br>
• Node.js<br>
• Java<br>
• Git<br>
• Linux<br>
        `);
        break;

      case "projects":
        addBlock(`
<br>📂 Projects:<br><br>
🏝 1. <a href="https://peace-island.vercel.app/" target="_blank" class="text-cyan-400 hover-underline">
3D Island Project</a><br><br>
🤖 2. <a href="https://ai-resume-analyzer-six-rust.vercel.app" target="_blank" class="text-cyan-400 hover-underline">
AI Resume Analyzer</a><br><br>
🌐 3. <a href="https://make-memory.vercel.app/" target="_blank" class="text-cyan-400 hover-underline">
Make Memory</a><br>
        `);
        break;

      case "github":
        addBlock(`
<br>🐙 GitHub:<br>
<a href="https://github.com/prakashrajsevugan" target="_blank" class="text-cyan-400 hover-underline">
github.com/prakashrajsevugan</a><br>
        `);
        break;

      case "contact":
        addBlock(`
<br>📧 Email:<br>
<a href="mailto:prakashraj8739@gmail.com" class="text-cyan-400 hover-underline">
prakashraj8739@gmail.com</a><br><br>
💼 LinkedIn:<br>
<a href="https://linkedin.com/in/prakashraj" target="_blank" class="text-cyan-400 hover-underline">
linkedin.com/in/prakashraj</a><br>
        `);
        break;

      case "photo":
        addBlock(`
<img src="/project_one.png" class="w-64 rounded-lg border border-green-400 mt-2" alt="Prakash Raj"/>
        `);
        break;

      case "clear":
        clearTerminal();
        break;

      case "exit":
        addLine("Closing portfolio... 👋 Goodbye!", "text-cyan-400 mt-2");
        deactivateTerminal();
        break;

      default:
        addLine("Command not found. Type 'help'", "text-red-400 mt-2");
    }
};

const activateTerminal = () => {
    isActive = true;
    terminalOverlay.style.display = 'none';
    terminalInput.disabled = false;
    terminalInput.classList.remove('inactive');
    terminalInput.classList.add('active');
    terminalInput.focus();
};

const deactivateTerminal = () => {
    isActive = false;
    terminalOverlay.style.display = 'block';
    terminalInput.disabled = true;
    terminalInput.classList.remove('active');
    terminalInput.classList.add('inactive');
};

terminalWindow.addEventListener('click', activateTerminal);

terminalInput.addEventListener('keydown', (e) => {
    if (!isActive) return;

    if (e.key === "Enter") {
        const inputVal = terminalInput.value;
        if (inputVal.trim() !== "") {
            history.push(inputVal);
            historyIndex = history.length;
        }

        addBlock(`<span class="text-yellow-400">prakash@portfolio:~$</span> ${inputVal}`);
        handleCommand(inputVal);
        terminalInput.value = "";
    }

    if (e.key === "ArrowUp") {
        e.preventDefault();
        if (historyIndex > 0) {
            historyIndex--;
            terminalInput.value = history[historyIndex];
        }
    }

    if (e.key === "ArrowDown") {
        e.preventDefault();
        if (historyIndex < history.length - 1) {
            historyIndex++;
            terminalInput.value = history[historyIndex];
        } else {
            historyIndex = history.length;
            terminalInput.value = "";
        }
    }
});

// Boot when loaded
boot();
